const plotColours = {
    default: [
        "#050C9C",
        "#3572EF", 
        "#3ABEF9",
        "#A7E6FF",
        "d75f6f",
        "f1515e",   
    ],
    contrast: [
        // https://coolors.co/228cdb-7eb77f-ffbe33-b80c09-664e4c-700353
        //https://coolors.co/228cdb-7eb77f-ffbe33-b80c09-af2bbf-000000
        '228cdb', // blue
        '7eb77f', // green
        'ffbe33',
        'b80c09',
        'af2bbf',
        '000000'
    ]
}

const windPlotColours = [
    'rgb(158, 202, 225)',  // Light Winds - Lighter blue
    'rgb(66, 146, 198)',   // Moderate Winds - Darker blue
    'rgb(91, 184, 93)',    // Fresh Winds - Green
    'rgb(254, 178, 76)',   // Strong Winds - Bright orange
    'rgb(240, 59, 32)',    // Near Gale - Bright red
    'rgb(128, 0, 38)',     // Gale Force - Deep red
];

const waveColorSchemes = [
    'rgb(158, 202, 225)',  // Calm - Lighter blue
    'rgb(66, 146, 198)',   // Smooth - Darker blue
    'rgb(91, 184, 93)',    // Slight - Green
    'rgb(254, 178, 76)',   // Moderate - Bright orange
    'rgb(240, 59, 32)',    // Rough - Bright red
    'rgb(128, 0, 38)',     // Very rough - Deep red
];

const obsBreakpoints = {
    Seconds: [0, 8, 10, 12, 15, 20, 1000],
    Metres: [0, 0.1, 0.5, 1.25, 2.5, 4, 1000],
    Knots: [0, 6, 15, 20, 33, 47, 1000],
};

function getLabel(bin) {
    if (bin[0] == 0) {
        return "<" + bin[1].toString() + "";
    } else if (bin[1] > 100) {
        return "≥" + bin[0].toString() + "";
    } else {
        return "[" + bin[0].toString() + "-" + bin[1].toString() + ")";
    }
}

function isInAngleBin(direction, directionEdges) {
    if (directionEdges[0] < 0) {
        if (direction > 360 + directionEdges[0]) {
            return true;
        }
        if (direction < directionEdges[1]) {
            return true;
        }
        return false;
    } else {
        return direction >= directionEdges[0] && direction <= directionEdges[1];
    }
}

function generateDirectionalBins(segmentDeg) {
    let numSegments = 360 / segmentDeg;
    const segmentHalf = segmentDeg / 2;

    let direction_bins = [];
    for (let i = 0; i < numSegments; i++) {
        let bin = [
            i * segmentDeg - segmentHalf,
            (i + 1) * segmentDeg - segmentHalf,
        ];
        direction_bins.push(bin);
    }
    return direction_bins;
}

function generateRose(data, segmentDeg, unit) {  // Remove colorScheme parameter since we'll use windPlotColours
    let directionalObservable = data.direction;
    let magnitudeObservable = data.magnitude;

    let directionBins = generateDirectionalBins(segmentDeg);
    let breakpoints = obsBreakpoints[unit];

    let observableBins = breakpoints.slice(0, -1).map((x, i) => {
        return [breakpoints[i], breakpoints[i + 1]];
    });

    var maxEntry = 0;
    let pdata = [];
    var pctChkSum = [];

    for (let sbin in observableBins) {
        var lowerMagnitudeEdge = observableBins[sbin][0];
        var uppperMagnitudeEdge = observableBins[sbin][1];
        var magnitudeFiltered = directionalObservable.filter((x_i, i) => {
            return (
                magnitudeObservable[i] >= lowerMagnitudeEdge &&
                magnitudeObservable[i] < uppperMagnitudeEdge
            );
        });

        let db = directionBins
            .map((x) =>
                magnitudeFiltered.reduce((acc, el) => {
                    return acc + isInAngleBin(el, x);
                }, 0)
            )
            .map((x) => (100 * x) / directionalObservable.length);

        let pct = db.reduce((acc, s) => acc + s, 0);
        pctChkSum.push(pct);

        maxEntry = Math.max(maxEntry, ...db);

        pdata.push({
            r: db,
            theta: [
                "N", "NNE", "NE", "ENE", "E", "ESE", "SE", "SSE",
                "S", "SSW", "SW", "WSW", "W", "WNW", "NW", "NNW",
            ],
            marker: { color: windPlotColours[Math.min(pdata.length, windPlotColours.length - 1)] },
            hovertemplate: "%{r:.2f}% %{theta} %{fullData.name} " + unit + " <extra></extra>",
            name: getLabel(observableBins[sbin]),
            type: "barpolar",
        });
    }

    let dtick = parseInt(maxEntry / 2);
    return [pdata, dtick];
}



// export  { generateRose, obsBreakpoints, plotColours, windPlotColours };
export { generateRose, obsBreakpoints, plotColours, windPlotColours, waveColorSchemes };